import { render, staticRenderFns } from "./CotacoesBaixadasComSucesso.vue?vue&type=template&id=009ba1f6&scoped=true"
import script from "./CotacoesBaixadasComSucesso.vue?vue&type=script&lang=js"
export * from "./CotacoesBaixadasComSucesso.vue?vue&type=script&lang=js"
import style0 from "./CotacoesBaixadasComSucesso.vue?vue&type=style&index=0&id=009ba1f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009ba1f6",
  null
  
)

export default component.exports